export const ROOT_URL = '/'

export const HOME = '/home'
export const OFFERS = '/offers'
export const PURCHASE_REPORTS = '/purchase-reports'


// auth
export const LOGIN = '/login'

export const DELETE_INFLUIO_APP_USER = '/delete/app/user'

export const APP_USER_LOGIN = '/app/user/login'
export const SIGN_UP = '/signUp'
export const LOGIN_USER = '/user/login';
export const GET_SESSION = '/user/get/session';
export const LOGOUT = '/user/logout';

//advertisers
export const GET_ALL_ADVERTISERS = "/partners/get";

// offers
export const GET_ALL_OFFERS = "/offers/get";


//signup
export const CREATE_NEW_USER = '/user/create';

//product performance
export const SAVE_NEW_EXCEL = '/excel/save/';
export const GET_ALL_CONVERSIONS = "/conversions/get";

export const DOWNLOAD_OFFER_PRODUCTS_EXCEL_DATA = '/conversions/download/excel';
export const GET_EXCEL_DATA = "/excel/get";


// affiliate performance
export const AFFILIATE_PERFORMANCE = '/affiliate-performance'
export const USERS_ADMIN = '/users-admin'
export const USERS_ADMIN_LIST = '/users-admin-list'
export const INSTAGRAM_NAME_FILLER = '/instagram-name-filler'
export const INSTAGRAM_NAME_FILLER_UPLOAD = '/instagram-name-filler/upload'
export const GET_ALL_AFFILIATES = '/affiliates/get'
export const GET_AFFILIATE_PERFORMANCE = '/affiliate/performance/get'
export const LCW_NEW_PARTNERS = '/a1dc6e64cb6ecedc99c3388af49d64d4/partners'

//has-offer-users
export const GET_ALL_HAS_OFFER_USERS = '/has-offer-users/get/all'
export const SEARCH_GENERAL_USERS = '/general-users/search'
export const GET_SELECTED_HAS_OFFER_USER = '/has-offer-users/get/selected'
export const UPDATE_SELECTED_HAS_OFFER_USER_ADDITIONAL_DATA = '/has-offer-users/additional_data/update'
export const ADD_NEW_LCW_USER = "/lcw/add/new";

export const DELETE_APP_USER = "/user/delete/account";

export const LOGIN_APP_USER = "/login/app/user";

export const ADD_DASHBOARD_USER = "/dashboard/has-offer-users/add/new";
export const UPDATE_SELECTED_HAS_OFFER_USER_DATA = '/has-offer-users/settings/update'
export const RESTORE_USER_ACCOUNT = '/restore/user/account';

export const MYSQL_USER_SETTINGS_UPDATE = '/users/update/general'
export const GET_SELECTED_HAS_OFFER_USER_BANK_DETAILS = '/has-offer-users/bank-details/selected'
export const UPDATE_SELECTED_HAS_OFFER_USER_BANK_DATA = '/has-offer-users/bank-details/update'
export const GENERATE_BANK_SETTINGS_UPDATE_LINK = '/has-offer-users/bank-details/generate-link';

export const DOWNLOAD_HAS_OFFERS_USERS_CSV = '/has-offer-users/download/csv';
export const DOWNLOAD_LCW_USERS_CSV = '/lcw-users/download/csv';


export const DOWNLOAD_PAID_PROJECT_INFLUENCERS = '/paid-projects/download/influencers';

//forms
export const USER_SETTINGS_UPDATE = '/forms/user-settings-update'
export const USER_BANK_SETTINGS_UPDATE = '/forms/user-bank-settings-update'
export const LCW_USER_NEW_REGISTRATION = '/forms/lcw-new-partner'
export const KARACA_USER_NEW_REGISTRATION = '/forms/karaca-new-partner'
export const GET_KARACE_PDF_URL = '/karaca/get/form-pdf';
export const ADD_NEW_KARACA_USER = "/karaca/add/new";
export const KARACA_NEW_PARTNERS = '/4fb6ad4678d2876cfd97650274bca7ad/partners'
export const GET_ALL_KARACA_USERS = '/karaca/get/all'
export const UPDATE_KARACA_USER_REVIEW_STATE = '/karaca/update/review-state'
export const DOWNLOAD_KARACA_USERS_CSV = '/karaca-users/download/csv'

export const LCW_LANDING_PAGE_URL = '/lcw/lcwbiziminfluencerimizsensinsss'
export const ABOUT_INFLUIO = '/influiohakkinda'
export const CUSTOM_PAGE = '/cp'

//lcw users
export const GET_ALL_LCW_USERS_STREAM = '/lcw/get/all/stream'
export const UPDATE_LCW_USER_REVIEW_STATE = '/lcw/update/review-state'
export const GET_LCW_FORM_PDF_URL = '/lcw/get/form-pdf';
//developer integration helper
export const INTEGRATIONS_HELPER = '/integrations-helper'


//advertiser management
export const ADVERTISER_MANAGEMENT = '/advertiser-management'
export const CREATE_CAMPAIGN = '/create-campaign'
export const INSERT_NEW_CAMPAIGN = "/campaigns/insert"
export const CREATE_PROMO_CODE = '/create-promo-code'

export const CREATE_PAID_PROJECT = '/create-paid-project'
export const UPLOAD_CAMPAIGN_IMAGE = '/campaigns/upload/image'
export const STATUS_CENTER = '/status-center'
export const INSERT_NEW_PROMO_CODE = "/promo-codes/insert"
export const GET_ALL_CATEGORIES = "/categories/get";
export const GET_ADVERTISER_PENDING_ASSETS = "/advertiser/pending-assets/get";

export const INSERT_NEW_PAID_PROJECTS = "/paid-projects/insertPaidProject";

export const INSERT_NEW_INFLUENCER_RELATION = "/paid-projects/insertInfluencerRelation";

export const UPDATE_PAID_PROJECT = "/paid-projects/updatePaidProject";
export const DELETE_PAID_PROJECT = "/paid-projects/delete";
export const UPDATE_PAID_PROJECT_INFLUENCER = "/paid-projects/update/influencer";

export const APPROVE_ALL_OR_REJECT_ALL_INFLUENCERS = "/paid-projects/approve/reject/all";


//integration helper
export const GET_TRACKER_POSTBACKS = "/adjust/get/postbacks";

export const ADMIN_PAID_PROJECTS = '/admin-paid-projects';

export const USER_PAYMENTS = '/user-payments';

export const EDIT_PROJECT = '/edit';

export const AI_GROUP = '/ai-assistant';

export const AI_CHAT_ASSISTANT = '/ai-chat-assistant';

export const AI_INFLUENCER_REVENUES = '/ai-assistant/influencer-revenues';

export const INFLUENCER_CHATS = '/influencer-chats';

export const INSERT_INFLUENCERS = '/influencers/insert';

export const ASSIGN_INFLUENCERS = '/assign-influencers';

export const GET_ALL_PROJECTS = '/projects/get/all';

export const GET_PAID_PROJECT_INFLUENCERS = '/paid-projects/get/influencers';

export const MLINK = '/mlink';

export const GET_ALL_MLINK_CAMPAIGNS = '/mlink/get/all';

export const GET_GENERATED_LINK = '/mlink/get/generated-link';

export const GET_MLINK_REPORTS = '/mlink/get/reports';

//payments service

export const GET_USER_PAYMENTS = '/payments/get/user';

export const GET_ALL_PAYMENTS = '/payments/get/all';

export const UPDATE_USER_PAYMENT = '/payment/update/user';

export const DELETE_USER_PAYMENT = '/payment/delete/user';
export const GET_IMAGE_URL = '/payments/user/get-invoice-signal-url';

export const SEND_FIRST_EXCEL_NEW_RECORDS = '/excel/send/first';

export const SEND_SECOND_EXCEL_UPDATE_RECORDS = '/excel/send/second';

export const DOWNLOAD_ALL_PAYMENTS_EXCEL_DATA = '/payments/download/all/excel';


//radar ai service

export const GET_ALL_POTENTIAL_INFLUENCERS = '/ai-assistant/get/all';

export const GET_ALL_POTENTIAL_INFLUENCERS_DATA_WITH_CHATS = '/ai-assistant/get/all-with-chats';

export const INSERT_POTENTIAL_INFLUENCERS = '/ai-assistant/insert';

export const DELETE_POTENTIAL_INFLUENCER = '/ai-assistant/delete';

export const START_CRAWLING_CHAT_IDS = '/influencer-chats/start-crawling-chat-ids'
export const GET_CHATS_AND_INFLUENCER_DATA = '/influencer-chats/get-influencers';
export const GET_CONVERTED_INFLUENCER_REVENUES = '/ai-assistant/get/influencer-revenues';

//create custom html pages
export const HANDLE_MISSING_OLD_HTML_PAGES = '/static/pages'
export const GET_ALL_PAGE_TYPES = '/html-templates/get/all';
export const UPDATE_CUSTOM_PAGE_DATA = '/html-templates/update';
export const GET_CUSTOM_PAGE_DATA_BY_LINK = '/html-templates/get-by-link';
export const INSERT_NEW_PAGE_TYPE = '/html-templates/insert';
export const UPLOAD_CUSTOM_PAGE_IMAGE = '/html-templates/upload-image';

// next-gen static pages editor
export const GET_ALL_CUSTOM_EDITOR_PAGES = '/html-editor/get/all';
export const GET_CUSTOM_EDITOR_PAGE_BY_LINK = '/html-editor/get-by-link';
export const INSERT_CUSTOM_EDITOR_PAGE = '/html-editor/insert';
export const UPDATE_CUSTOM_EDITOR_PAGE = '/html-editor/update';
export const UPLOAD_CUSTOM_EDITOR_IMAGE = '/html-editor/upload-image';
export const GET_CUSTOM_EDITOR_ICON_LIBRARY = '/html-editor/icons/library';



//brand - influencer reports

export const BRAND_INFLUENCER_REPORTS = '/brand-influencer-reports';

export const GET_ALL_BRANDS_INFLUENCERS_CONVERSIONS = '/brand-influencer-reports/get/all';

export const DOWNLOAD_BRANDS_INFLUENCERS_CONVERSIONS_EXCEL_DATA = '/brand-influencer-reports/download/excel';


//nano projects main url
export const NANO_PROJECTS = '/nano-projects';


//rejected conversions correct excel
export const EXCEL_CONVERSIONS_REJECTED = '/excel/conversions/rejected';
export const CORRECT_CONVERSIONS_CSV_EXPORT_EXCEL = '/excel/conversions/rejected/export/excel';
export const GET_ALL_REJECTED_CONVERSIONS_PAYOUT_INFLUENCERS = '/excel/conversions/rejected/get/all';
export const DELETE_REJECTED_CONVERSION_INFLUENCER = '/excel/conversions/rejected/delete/influencer';
export const ADD_REJECTED_CONVERSION_INFLUENCER = '/excel/conversions/rejected/add/influencer';

export const SHARE_LINK_INTEGRATION = '/integrations/share-link';

export const AI_ASSISTANT_NEW = '/influiogpt';
export const AI_ASSISTANT_MOBILE = '/influiogpt-mobile';
export const AI_CHAT_STREAM = '/ai/chat/stream';
export const AI_CHAT_HISTORY = '/ai/chat/history';

// Influio TV (master only)
export const INFLUIO_TV = '/influio-tv';
export const INFLUIO_TV_SCRIPT = '/influio-tv/script';
export const INFLUIO_TV_TTS = '/influio-tv/tts';
export const INFLUIO_TV_EPISODES = '/influio-tv/episodes';
export const INFLUIO_TV_WITHDRAW_EPISODE = '/influio-tv/episodes/withdraw';
export const INFLUIO_TV_IMAGE = '/influio-tv/image';
export const PAID_PROJECT_INFLUENCER_VIDEOS = '/paid-projects/influencer-videos';
export const PAID_PROJECT_INFLUENCER_VIDEOS_UPLOAD_URL = '/paid-projects/influencer-videos/upload-url';
export const PAID_PROJECT_INFLUENCER_VIDEOS_UPDATE = '/paid-projects/influencer-videos/update';
export const PAID_PROJECT_INFLUENCER_VIDEOS_DELETE = '/paid-projects/influencer-videos/delete';
